import React from 'react';
import { XMarkIcon, ExclamationTriangleIcon, CheckCircleIcon, InformationCircleIcon } from '@heroicons/react/24/outline';
import { useToasts } from '../state/ToastContext';

const toneStyles: Record<string, string> = {
  info: 'bg-slate-900/90 text-white border border-slate-700',
  success: 'bg-emerald-600 text-white border border-emerald-500',
  warning: 'bg-amber-500 text-slate-900 border border-amber-400',
  error: 'bg-rose-600 text-white border border-rose-500',
};

const toneIcon: Record<string, typeof InformationCircleIcon> = {
  info: InformationCircleIcon,
  success: CheckCircleIcon,
  warning: ExclamationTriangleIcon,
  error: ExclamationTriangleIcon,
};

const ToastStack: React.FC = () => {
  const { toasts, dismissToast } = useToasts();

  if (toasts.length === 0) {
    return null;
  }

  return (
    <div className="pointer-events-none fixed right-6 top-6 z-[60] flex w-full max-w-xs flex-col gap-3 sm:max-w-sm">
      {toasts.map((toast) => {
        const tone = toast.tone ?? 'info';
        const Icon = toneIcon[tone] ?? InformationCircleIcon;
        return (
          <div
            key={toast.id}
            className={`pointer-events-auto rounded-2xl px-4 py-3 text-sm shadow-xl backdrop-blur ${toneStyles[tone]}`}
          >
            <div className="flex items-start gap-3">
              <Icon className="mt-0.5 h-5 w-5 flex-shrink-0" />
              <div className="flex-1">
                <p className="font-semibold">{toast.message}</p>
                {toast.detail ? <p className="text-xs/relaxed opacity-90">{toast.detail}</p> : null}
              </div>
              <button
                type="button"
                className="rounded-full p-1 text-xs opacity-70 transition hover:opacity-100"
                onClick={() => dismissToast(toast.id)}
              >
                <XMarkIcon className="h-4 w-4" />
              </button>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default ToastStack;
